import React from "react";
import DarkModeToggle from "./DarkModeToggle";

function Header({ darkMode, onToggleDark, onNavClick }) {
  return (
    <header className="site-header">
      <div className="container header-inner">
        <div className="logo">
          <img className="logo-mark" src="/logo.jpeg" alt="BBI" />
          <span className="logo-text no-wrap">Beyond Badminton Central Coast</span>
        </div>
        <nav className="nav">
          <button onClick={() => onNavClick("home")}>Home</button>
          <button onClick={() => onNavClick("club-info")}>Club Info</button>
          <button onClick={() => onNavClick("membership")}>Membership</button>
          <button onClick={() => onNavClick("sessions")}>Sessions</button>
          <button onClick={() => onNavClick("about")}>About Us</button>
          {/* <button onClick={() => onNavClick("gallery")}>Club Moments</button> */}
          <button onClick={() => onNavClick("contact")}>Contact Us</button>
        </nav>
        <div className="header-actions">
          <DarkModeToggle darkMode={darkMode} onToggle={onToggleDark} />
          <button
            className="btn btn-primary btn-small"
            onClick={() => onNavClick("membership")}
          >
            Join BBI
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
